import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=3da18d34&scoped=true"
import script from "./Finish.vue?vue&type=script&lang=js"
export * from "./Finish.vue?vue&type=script&lang=js"
import style0 from "./Finish.vue?vue&type=style&index=0&id=3da18d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da18d34",
  null
  
)

export default component.exports